module.exports = __webpack_public_path__ + "static/media/bonus1.a1388aa4.png";